import type { RouteObject } from "react-router"

import { DataManagerGuard } from "@/components/route/data-manager-guard"
import { FeatureGuard } from "@/components/route/featureGuard/featureGuard"
import { LimitedAccessUserGuard } from "@/components/route/limited-access-user-guard"
import { DataPath, RootPath } from "@/models/route"

import { DataIndexRoute } from "./pages/data-index-route"
import { DataOutlierRoute } from "./pages/data-outlier-route"
import { DataQARoute } from "./pages/data-qa-route"
import { DataUploadRoute } from "./pages/data-upload-route"

export const dataRoutes: RouteObject[] = [
  {
    path: RootPath.Data,
    element: (
      <DataManagerGuard feature="data_manager">
        <LimitedAccessUserGuard>
          <DataIndexRoute />
        </LimitedAccessUserGuard>
      </DataManagerGuard>
    ),
    children: [
      {
        path: DataPath.Upload,
        element: (
          <DataManagerGuard feature="data_manager_upload">
            <DataUploadRoute />
          </DataManagerGuard>
        ),
      },
      {
        path: DataPath.QA,
        element: <DataQARoute />,
      },
      {
        path: DataPath.Outlier,
        element: (
          <FeatureGuard feature="data_manager_outlier_monitor">
            <DataOutlierRoute />
          </FeatureGuard>
        ),
      },
    ],
  },
]
